import $ from 'jquery';

export default class Overlay {
  constructor(el, trigger, stateChangeCallback) {

    if (el === null && trigger === null) {
      return;
    }

    this.$el = $(el);
    this.$trigger = $(trigger);
    this.close = this.$el.find('[class*="__close"]')[0];
    this.$close = $(this.close);
    this.background = this.$el.find('[class*="__background"]')[0];
    this.$background = $(this.background);

    this.openClass = 'is-open';

    this.state = {
      isOpen: false
    };

    this.init();
    this.callback = stateChangeCallback;
  }

  addEvents() {
    if (this.$trigger.length !== 0) {
      this.$trigger.click(this.toggleOverlay.bind(this));
    }
    if (this.$close.length !== 0) {
      this.$close.click(this.toggleOverlay.bind(this));
    }
    if (this.$background.length !== 0) {
      this.$background.click(this.toggleOverlay.bind(this));
    }
  }

  toggleOverlay() {
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    if (!this.state.isOpen) {
      this.state.isOpen = true;
      if (this.$el.length !== 0) {
        this.$el.addClass(this.openClass);
      }
      bodyLock();
    }
    else {
      this.state.isOpen = false;
      if (this.$el.length !== 0) {
        this.$el.removeClass(this.openClass);
      }
      bodyUnlock();
    }

    this.callback(this.state.isOpen);
  }

  init() {
    this.addEvents();
  }
}

export function bodyLock() {
  const $body = $('body');
  $body.addClass('no-scroll');
}

export function bodyUnlock() {
  const $body = $('body');
  $body.removeClass('no-scroll');
}
